import axios from "@/axios";

export const namespaced = true;

export const state = {
  userAuditLog: [],
  loadingText: "Results Loading...",
  totalAuditLogCount : null,
  totalUniqueActionCount: null
};

export const getters = {
  getUserAuditLog: (state) => {
    return state.userAuditLog;
  },
  getTotalUserAuditLogCount: (state) => {
    return state.totalAuditLogCount
  },
  getTotalUniqueActionCount: (state) => {
    return state.totalUniqueActionCount
  },
  auditLogLoadingText: (state) => {
    return state.loadingText;
  },
};

export const mutations = {
  SET_USER_AUDIT_LOG(state, auditLog) {
    // Concat like order audit log does - works with CLEAR pattern
    state.userAuditLog = state.userAuditLog.concat(auditLog);
  },
  CLEAR_USER_AUDIT_LOG(state) {
    state.userAuditLog = [];
  },
  SET_USER_AUDIT_LOG_LENGTH(state , number){
    state.totalAuditLogCount = number
  },
  SET_TOTAL_UNIQUE_ACTION_COUNT(state, number) {
    state.totalUniqueActionCount = number
  },
  SET_USER_AUDIT_LOG_LOADING_TEXT(state, text) {
    state.auditLogLoadingText = text;
  },
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_USER_AUDIT_LOG");
  },
  async fetchAuditLog({ commit }, orderId = 0) {
    if (orderId != 0) {
      await axios
        .get(`/api/userauditlogs/${orderId}`)
        .then((res) => {
          if (res.data.length > 0) {
            commit("SET_USER_AUDIT_LOG_LOADING_TEXT", "Audit Logs Loaded...");
            commit("SET_USER_AUDIT_LOG", res.data);
          } else {
            commit("SET_USER_AUDIT_LOG_LOADING_TEXT", "No Audit Logs Available!");
          }
        })
        .catch((err) => {
          //console.log(err); //not handelled
        });
    } else {
      commit("CLEAR_USER_AUDIT_LOG");
      //commit("SET_AUDIT_LOG", DummyAuditData);
    }
  },
  async fetchAuditLogPagination({ commit }, apiInfo) {
    try {
      // Clear before fetching if requested (production pattern)
      if(apiInfo.isClear) {
        commit("CLEAR_USER_AUDIT_LOG");
      }
      
      let res = await axios
      .get(`/api/userauditlogs/pagination/${apiInfo.userId}/${apiInfo.pageNumber}/${apiInfo.resultsPerPage}/${apiInfo.searchText}`)

       // commit or return
       if (res.data.results.length > 0) {

      commit("SET_USER_AUDIT_LOG_LOADING_TEXT", "Audit Logs Loaded...");
          // Always concat - if isClear was true, array was already cleared above
          commit("SET_USER_AUDIT_LOG", res.data.results);
          commit("SET_USER_AUDIT_LOG_LENGTH", res.data.recordCount)
          commit("SET_TOTAL_UNIQUE_ACTION_COUNT", res.data.totalUniqueActionCount)
      }  else {
        commit("SET_USER_AUDIT_LOG_LOADING_TEXT", "No Audit Logs Available!");
      }
    } catch(err) {
      //console.log(err);
    }
  },
};
